import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import {
  IrpfAscendantDto,
  IrpfDescendantDto,
  IrpfIndividualDto,
  IrpfPensionPaymentDto
} from '@app/data/dtos/ptrab/irpf/irpf.dto';
import { IrpfSections } from '@app/entities/enums/ptrab/irpf.enum';
import { IDataObjectResponse } from '@app/entities/interfaces/data/data.interface';
import { TwoFactorAuthorization } from '@app/entities/interfaces/ptrab/two-factor-authorization.interface';
import { IrpfModel } from '@app/entities/models/ptrab/irpf/irpf.model';

export interface IrpfRepository {
  getData(): Observable<IrpfModel>;
  modifyIrpfData(
    params: IDataObjectResponse<
      IrpfIndividualDto | IrpfDescendantDto[] | IrpfAscendantDto[] | IrpfPensionPaymentDto | boolean,
      string
    >,
    section: IrpfSections,
    authorization?: TwoFactorAuthorization
  ): Observable<IrpfModel>;
}

export const IRPF_REPOSITORY = new InjectionToken<IrpfRepository>('IRPF_REPOSITORY');
